import { render, staticRenderFns } from "./zanneixin-detail.vue?vue&type=template&id=e19866f8&scoped=true&"
import script from "./zanneixin-detail.vue?vue&type=script&lang=js&"
export * from "./zanneixin-detail.vue?vue&type=script&lang=js&"
import style0 from "./zanneixin-detail.scss?vue&type=style&index=0&id=e19866f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e19866f8",
  null
  
)

export default component.exports